import React from 'react';
import { Hero } from './components/Hero';
import { Problem } from './components/Problem';
import { Solution } from './components/Solution';
import { Contents } from './components/Contents';
import { UniqueMechanism } from './components/UniqueMechanism';
import { Pricing } from './components/Pricing';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen font-sans text-gray-900 bg-white selection:bg-rose-200 selection:text-rose-900" data-id="element-0">
      <Hero data-id="element-1" />
      <Problem data-id="element-2" />
      <Solution data-id="element-3" />
      <Contents data-id="element-4" />
      <UniqueMechanism data-id="element-5" />
      <Pricing data-id="element-6" />
      <FAQ data-id="element-7" />
      <Footer data-id="element-8" />
    </div>;
}